import { ToastContainer } from "react-toastify";
import Pages from "./Pages";
import "react-toastify/dist/ReactToastify.css";
import useTheme from "./utils/useTheme";
import { useEffect } from "react";
import Loader from "./Components/ProgressBar/Loader";
import { getAllConfigs } from "./utils/network/Crud";

function App() {
  const { toggleGlobalLoading, globalLoading, setConfigs } = useTheme();

  const getConfigData = async () => {
    try {
      const response = await getAllConfigs();

      if (!response?.data) return;

      const findConfig = (id) => response.data.find((c) => c.id === id);

      setConfigs((prev) => ({
        ...prev,
        showLive: findConfig("showLive")?.showLive ?? prev.showLive,
        channelId: findConfig("channelId")?.channelId ?? prev.channelId,
        liveVideoId: findConfig("liveVideoId")?.liveVideoId ?? prev.liveVideoId,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    toggleGlobalLoading(true);
    getConfigData().finally(() => toggleGlobalLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (globalLoading) return <Loader />;

  return (
    <>
      <ToastContainer />
      <Pages />
    </>
  );
}

export default App;
